module.exports = __webpack_public_path__ + "img/selected1-min.0cf07664.png";